module.exports = __webpack_public_path__ + "img/5.c3028d44.png";